module.exports = __webpack_public_path__ + "img/report-lg.f491db51.png";